var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { ref: "container", staticClass: "container" }, [
    _c(
      "div",
      {
        staticClass: "dashboard",
        class: {
          "double-margin": _vm.bottomOfScreen && !_vm.ordersNotProvided.length,
          "extra-margin": _vm.ordersNotProvided.length,
          "double-extra-margin":
            _vm.bottomOfScreen && _vm.ordersNotProvided.length
        }
      },
      [
        _c(
          "div",
          { staticClass: "left" },
          [
            _c(
              "div",
              { staticClass: "mobile" },
              [
                _vm.firstOrderUser ? _c("BannerFirstOrder") : _vm._e(),
                _vm._v(" "),
                _c("EmailNotVerifiedNotice")
              ],
              1
            ),
            _vm._v(" "),
            _c("Welcome", {
              attrs: {
                ordersNotProvided: _vm.ordersNotProvided,
                isAtBottomOfWindow: _vm.bottomOfScreen
              }
            }),
            _vm._v(" "),
            _c("transition", { attrs: { name: "down", mode: "out-in" } }, [
              _vm.preloader
                ? _c(
                    "div",
                    { staticClass: "loader" },
                    [
                      _c("Loader", { attrs: { indeterminate: "" } }),
                      _vm._v(" "),
                      _c("p", [_vm._v(_vm._s(_vm.loadingMessage))])
                    ],
                    1
                  )
                : _vm._e()
            ]),
            _vm._v(" "),
            !_vm.preloader && _vm.noFutureOrders ? _c("Empty") : _vm._e(),
            _vm._v(" "),
            _c("ProvisioningPayables", {
              attrs: { ordersProvisioning: _vm.ordersProvisioning }
            }),
            _vm._v(" "),
            _c("PendingPayables", {
              attrs: {
                pendingOrders: _vm.pendingOrders,
                pendingCycles: _vm.pendingCycles
              }
            }),
            _vm._v(" "),
            _c("ConfirmedPayables", {
              attrs: { confirmedOrders: _vm.confirmedOrders }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "right" },
          [
            _c(
              "div",
              { staticClass: "desktop" },
              [
                _vm.firstOrderUser ? _c("BannerFirstOrder") : _vm._e(),
                _vm._v(" "),
                _c("EmailNotVerifiedNotice")
              ],
              1
            ),
            _vm._v(" "),
            _c("InfoCards")
          ],
          1
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-142d5ff7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-142d5ff7","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Index.vue
// module id = null
// module chunks = 